import { Box, Button, Typography, styled } from '../../../base';
import { Directions } from '../../../common';

export const StyledCompanyQuestionContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    maxWidth: '600px', // Constrain width for better readability
    margin: 'auto',
}));

export const StyledTopSection = styled(Box)(({ theme }) => ({
    textAlign: 'start',
    alignSelf: 'flex-start',
    width: '100%',
    marginBottom: theme.spacing(3),
}));

export const StyledMiddleSection = styled(Box)(({ theme }) => ({
    width: '100%',
    marginBottom: theme.spacing(3),
    // Max height and overflow for the scrollable area will be handled by SingleSelectionAction.styles.ts
    // This ensures the CompanyQuestion component remains generic for other answer types.
}));

export const StyledBottomSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingTop: theme.spacing(2),
    gap: theme.spacing(2),
    '& > *:first-of-type': {
        order: theme.direction === Directions.RTL ? 2 : 1,
    },
    '& > *:last-of-type': {
        order: theme.direction === Directions.RTL ? 1 : 2,
    },
}));

export const StyledButton = styled(Button)(({ theme, variant }) => ({
    minWidth: '120px',
    padding: theme.spacing(1, 3),
    borderRadius: '20px', // Rounded buttons like in the image
    ...(variant === 'outlined' && {
        borderColor: '#C4C4C4', // Greyish border for skip
        color: '#6B6B6B', // Greyish text for skip
        '&:hover': {
            borderColor: '#A0A0A0',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    }),
    ...(variant === 'contained' && {
        backgroundColor: '#7F00FF', // Purple color for Answer
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: '#6A00D6',
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
        },
    }),
}));

export const StyledQuestionText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: theme.typography.h4.fontSize,
}));

export const StyledSubtitleText = styled(Typography)(() => ({
    // No specific style changes requested beyond alignment via StyledTopSection
}));
